.pin-marker {
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  position: relative;
  background: #fff;
  padding: 3px;
  transition:
    box-shadow 0.2s,
    transform 0.2s,
    z-index 0.2s;
}

.pin-marker:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);
  transform: scale(1.08);
}

.pin-icon {
  border-radius: 24px;
  padding: 3px;
  min-width: 22px;
  min-height: 23px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pin-arrow {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid white;
  position: absolute;
  bottom: -6px;
}

gmp-advanced-marker:hover {
  z-index: 1000;
}
